import type { DesignElement } from '@canvas/shared-types';
import { svgDataUrl } from '@/lib/svgDataUrl';

function icon(
  id: string,
  name: string,
  svg: string,
  tags: string[],
  audience: DesignElement['audience'] = 'all'
): DesignElement {
  const url = svgDataUrl(svg);
  return {
    elementId: id,
    name,
    kind: 'icon',
    category: 'icons',
    tags,
    audience,
    license: 'free',
    preview: { mode: 'image', value: url, label: name },
    defaultWidth: 96,
    defaultHeight: 96,
    factory: { type: 'image-url', url },
  };
}

const stroke = (paths: string) => `
<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 24 24" fill="none"
  stroke="#152033" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
  ${paths}
</svg>`;

export const ICON_CATALOG: DesignElement[] = [
  icon('icon-check', 'Check', stroke('<path d="M5 12l5 5L20 7"/>'), ['success', 'done']),
  icon(
    'icon-star',
    'Star',
    stroke('<path d="M12 3l2.5 6.5H21l-5 4 2 7-6-3.5L6 20.5l2-7-5-4h6.5z"/>'),
    ['favorite', 'rating']
  ),
  icon(
    'icon-book',
    'Book',
    stroke('<path d="M4 5h7a3 3 0 013 3v11H7a3 3 0 00-3 3V5zM20 5h-7a3 3 0 00-3 3v11h7a3 3 0 013-3V5z"/>'),
    ['study', 'course'],
    'student'
  ),
  icon(
    'icon-briefcase',
    'Briefcase',
    stroke(
      '<rect x="3" y="7" width="18" height="13" rx="2"/><path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2M3 12h18"/>'
    ),
    ['work', 'career'],
    'professional'
  ),
  icon(
    'icon-user',
    'User',
    stroke('<circle cx="12" cy="8" r="3.5"/><path d="M5 19a7 7 0 0114 0"/>'),
    ['profile', 'person']
  ),
  icon(
    'icon-mail',
    'Mail',
    stroke('<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 7 9-7"/>'),
    ['email', 'contact']
  ),
  icon(
    'icon-calendar',
    'Calendar',
    stroke(
      '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 11h18"/>'
    ),
    ['schedule', 'date']
  ),
  icon(
    'icon-chart',
    'Chart',
    stroke('<path d="M4 19V5M4 19h16M8 16V10M12 16V7M16 16v-4"/>'),
    ['data', 'stats'],
    'professional'
  ),
  icon(
    'icon-lightbulb',
    'Idea',
    stroke(
      '<path d="M9 18h6M10 21h4M12 3a6 6 0 00-3 11c.5.4 1 1.2 1 2h4c0-.8.5-1.6 1-2A6 6 0 0012 3z"/>'
    ),
    ['idea', 'innovation'],
    'student'
  ),
  icon(
    'icon-link',
    'Link',
    stroke(
      '<path d="M10 13a5 5 0 007 0l2-2a5 5 0 00-7-7l-1 1"/><path d="M14 11a5 5 0 00-7 0l-2 2a5 5 0 007 7l1-1"/>'
    ),
    ['url', 'connect']
  ),
  icon(
    'icon-image',
    'Image',
    stroke(
      '<rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="10" r="1.5"/><path d="M3 16l5-4 4 3 3-2 6 4"/>'
    ),
    ['photo', 'media']
  ),
  icon(
    'icon-target',
    'Target',
    stroke('<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="4"/><circle cx="12" cy="12" r="1"/>'),
    ['goal', 'focus'],
    'professional'
  ),
];
